"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var IconBase_1 = __importDefault(require("../IconBase"));
var AlertStar = function (props) { return (react_1.default.createElement(IconBase_1.default, __assign({}, props),
    react_1.default.createElement("path", { d: "M12 19L6.53337 21.8666C5.8667 22.2 5.0667 21.9333 4.73337 21.3333C4.60003 21.0666 4.53337 20.8 4.60003 20.4666L5.6667 14.4L1.2667 10.1333C0.733366 9.59998 0.733366 8.79998 1.2667 8.26665C1.4667 8.06665 1.73337 7.93331 2.00003 7.86665L8.0667 6.99998L10.8 1.46665C11.1334 0.799982 11.9334 0.533315 12.6 0.866649C12.8667 0.999982 13.0667 1.19998 13.2 1.46665L15.9334 6.99998L22 7.86665C22.7334 7.99998 23.2667 8.66665 23.1334 9.39998C23.0667 9.66665 22.9334 9.93332 22.7334 10.1333L18.3334 14.4L19.4 20.4666C19.5334 21.2 19.0667 21.8666 18.3334 22C18.0667 22.0666 17.7334 22 17.4667 21.8666L12 19Z" }))); };
exports.default = AlertStar;
